// Place Details field masks organized by Google Places API SKU tiers
export const PLACE_FIELD_MASKS = {
  // Place Details Essentials IDs Only SKU
  ESSENTIALS_IDS_ONLY: {
    attributions: "attributions",
    id: "id",
    moved_place: "moved_place",
    moved_place_id: "moved_place_id",
    name: "name",
    photos: "photos",
  },
  // Place Details Essentials SKU
  ESSENTIALS: {
    addressComponents: "addressComponents",
    addressDescriptor: "addressDescriptor",
    adrFormatAddress: "adrFormatAddress",
    formattedAddress: "formattedAddress",
    location: "location",
    plusCode: "plusCode",
    postalAddress: "postalAddress",
    shortFormattedAddress: "shortFormattedAddress",
    types: "types",
    viewport: "viewport",
  },
  // Place Details Pro SKU
  PRO: {
    accessibilityOptions: "accessibilityOptions",
    businessStatus: "businessStatus",
    containingPlaces: "containingPlaces",
    displayName: "displayName",
    googleMapsLinks: "googleMapsLinks",
    googleMapsUri: "googleMapsUri",
    iconBackgroundColor: "iconBackgroundColor",
    iconMaskBaseUri: "iconMaskBaseUri",
    primaryType: "primaryType",
    primaryTypeDisplayName: "primaryTypeDisplayName",
    pureServiceAreaBusiness: "pureServiceAreaBusiness",
    subDestinations: "subDestinations",
    utcOffsetMinutes: "utcOffsetMinutes",
  },
  // Place Details Enterprise SKU
  ENTERPRISE: {
    currentOpeningHours: "currentOpeningHours",
    currentSecondaryOpeningHours: "currentSecondaryOpeningHours",
    internationalPhoneNumber: "internationalPhoneNumber",
    nationalPhoneNumber: "nationalPhoneNumber",
    priceLevel: "priceLevel",
    priceRange: "priceRange",
    rating: "rating",
    regularOpeningHours: "regularOpeningHours",
    regularSecondaryOpeningHours: "regularSecondaryOpeningHours",
    userRatingCount: "userRatingCount",
    websiteUri: "websiteUri",
  },
  // Place Details Enterprise + Atmosphere SKU
  ENTERPRISE_ATMOSPHERE: {
    allowsDogs: "allowsDogs",
    curbsidePickup: "curbsidePickup",
    delivery: "delivery",
    dineIn: "dineIn",
    editorialSummary: "editorialSummary",
    evChargeAmenitySummary: "evChargeAmenitySummary",
    evChargeOptions: "evChargeOptions",
    fuelOptions: "fuelOptions",
    generativeSummary: "generativeSummary",
    goodForChildren: "goodForChildren",
    goodForGroups: "goodForGroups",
    goodForWatchingSports: "goodForWatchingSports",
    liveMusic: "liveMusic",
    menuForChildren: "menuForChildren",
    neighborhoodSummary: "neighborhoodSummary",
    parkingOptions: "parkingOptions",
    paymentOptions: "paymentOptions",
    outdoorSeating: "outdoorSeating",
    reservable: "reservable",
    restroom: "restroom",
    reviews: "reviews",
    reviewSummary: "reviewSummary",
    servesBeer: "servesBeer",
    servesBreakfast: "servesBreakfast",
    servesBrunch: "servesBrunch",
    servesCocktails: "servesCocktails",
    servesCoffee: "servesCoffee",
    servesDessert: "servesDessert",
    servesDinner: "servesDinner",
    servesLunch: "servesLunch",
    servesVegetarianFood: "servesVegetarianFood",
    servesWine: "servesWine",
    takeout: "takeout",
  },
} as const;
